// invoiceFormat — pure formatters + client-side rule re-evaluation shared by the
// processing dashboard and the review workspace. Keeps display logic testable and
// out of the components.

// fmtMoney renders integer cents as €90.00, appending the ISO code when ≠ EUR.
export const fmtMoney = (cents, currency = "EUR") => {
  const n = Number(cents || 0) / 100;
  const cur = (currency || "EUR").toUpperCase();
  const sym = cur === "EUR" ? "€" : cur === "USD" ? "$" : "";
  const body = `${sym}${n.toFixed(2)}`;
  return cur === "EUR" ? body : `${body} ${cur}`;
};

// fmtDate renders YYYY-MM-DD as "29 Jun 2026"; "—" for empty.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const fmtDate = (iso) => {
  if (!iso) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  return `${Number(m[3])} ${MONTHS[Number(m[2]) - 1]} ${m[1]}`;
};

// sourceLabel maps a stored source to a finance-facing label.
export const sourceLabel = (src) => {
  if (src === "manual") return "Manual";
  if (["mailgun", "mailjet", "oauth"].includes(src)) return "Email";
  return src || "—";
};

// confidenceBadge maps a 0..1 confidence to {label, tone}. null → em dash / neutral.
export const confidenceBadge = (v) => {
  if (v == null) return { label: "—", tone: "neutral" };
  const pct = Math.round(v * 100);
  if (v >= 0.9) return { label: `High ${pct}%`, tone: "ok" };
  if (v >= 0.7) return { label: `Medium ${pct}%`, tone: "attention" };
  return { label: `Low ${pct}%`, tone: "critical" };
};

// exceptionTone: duplicate is the hard (red) exception; others are amber.
export const exceptionTone = (exc) => (exc === "Possible duplicate" ? "critical" : "attention");

// evaluateException mirrors the engine's blocking-rule intent for live validation in
// the workspace (vendor/number/date/amount/currency). Duplicate/low-confidence are
// server-owned and NOT re-evaluated here. Returns "" when nothing blocks.
export const evaluateException = (f = {}) => {
  if (!f.vendor) return "Unknown vendor";
  if (!f.invoice_number) return "Missing invoice number";
  if (!/^\d{4}-\d{2}-\d{2}$/.test(f.invoice_date || "")) return "Missing invoice date";
  if (!(Number(f.amount_cents) > 0)) return "Missing amount";
  if ((f.currency || "").length !== 3) return "Currency mismatch";
  return "";
};
